import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../../../theme';

import CreatePostButton from '../action-buttons/create-post-button';
// import PrintPageButton from '../action-buttons/print-page-button';
import FaqActionButton from '../action-buttons/tips-faq-button';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
    },
  }),
);

export default function PostActions(props: any) {
  const classes = useStyles(baseTheme);

  return (
    <Grid item container xs={12} md={4} className={classes.root}>
      <CreatePostButton />
      {/* <PrintPageButton /> */}
      <FaqActionButton postType="Public" />
    </Grid>
  );
}
